const translations = {
  "breadCrumb.home": "Home",
  "breadCrumb.insurance-and-more": "Insurance and more",
  "breadCrumb.evaluations": "Evaluations",
  "breadCrumb.blogs": "News and blog",
  "breadCrumb.student": "Insurance for foreign students",
  "breadCrumb.vacancy": "Vacancy",
  "breadCrumb.aboutus": "About Us",
  "breadCrumb.offices": "Offices",
  "breadCrumb.chat-bot": "Imedi L Bot",
  "breadCrumb.our-team": "Our Team",
  "breadCrumb.more-about-insurance": "More About Insurance",
  "breadCrumb.legal-info": "Legal Information",
  "breadCrumb.financial-info": "Financial Information",
  "breadCrumb.corp-insurance": "Corporate Health Insurance",
  "breadCrumb.travel": "Travel Insurance",
  "breadCrumb.blog-details": "News",
  "breadCrumb.saerto": "Individual Health Insurance",
  "breadCrumb.paymentResult": "Policy Purchase",
  "breadCrumb.saerto.buypage": "Purchase Policy",
  "breadCrumb.saerto.paypage": "Policy Price Payment",
  "breadCrumb.gephaProposal": "Gepha offer",
  "breadCrumb.uno": "Uno / Uno+",
  "breadCrumb.uno.buypage": "Purchase Policy",
  "breadCrumb.uno.paypage": "Policy Price Payment",
  "breadCrumb.InsideTravelInsurance": "Visitors' Insurance in Georgia",
  "breadCrumb.tootsie": "Tootsie",
  "breadCrumb.privacyPolicies": "Privacy Policy",
  "breadCrumb.privacyStatement": "Privacy Statement",
  "breadCrumb.uno-active": "Uno Active / Uno Active+",
  "breadCrumb.uno-active.buypage": "Purchase Policy",
  "breadCrumb.uno-active.paypage": "Policy Price Payment",
  "breadCrumb.uno-select": "Uno Select",
  "breadCrumb.uno-select.buypage": "Purchase Policy",
  "breadCrumb.uno-select.paypage": "Policy Price Payment",
};

export default translations;
